import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getProject = createSelector(getModel, (model) => model.project);

export const getIsFetchingProject = createSelector(
    getProject,
    (value) => value.isFetching,
);

export const getProjectData = createSelector(getProject, (value) => value.data);
